import { KeyboardShortcutTag, KeyboardShortcutTagProps } from 'common/KeyboardShortcutTag/KeyboardShortcutTag'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { TooltipProps } from 'components/Tooltip/Types'
import React from 'react'

export type ShortcutAwareTooltipProps = {
  label: string
  shortcutKeys?: KeyboardShortcutTagProps['keys']
  shortcutModifiers?: KeyboardShortcutTagProps['modifiers']
  placement?: TooltipProps['placement']
}

export const ShortcutAwareTooltip: React.FC<
  React.PropsWithChildren<ShortcutAwareTooltipProps & { children: React.ReactElement }>
> = ({ children, label, shortcutKeys, shortcutModifiers, placement = 'top' }) => {
  let labelEl: string | React.ReactElement = label
  if (shortcutKeys && shortcutModifiers) {
    labelEl = (
      <>
        {label} <KeyboardShortcutTag modifiers={shortcutModifiers} keys={shortcutKeys} />
      </>
    )
  }

  return (
    <Tooltip label={labelEl} placement={placement}>
      {children}
    </Tooltip>
  )
}
